import React, { useState } from 'react';
import classnames from 'classnames';
import InputLayout from '../InputLayout';
import s from './Textarea.scss';
var Textarea = React.forwardRef(function (_a, ref) {
    var label = _a.label, wrapperClassName = _a.wrapperClassName, maxLength = _a.maxLength, error = _a.error, name = _a.name, placeholder = _a.placeholder, errorMessage = _a.errorMessage, id = _a.id, value = _a.value, defaultValue = _a.defaultValue, textareaClassName = _a.textareaClassName, charactersRemainingClassName = _a.charactersRemainingClassName, rows = _a.rows, fullHeight = _a.fullHeight, skin = _a.skin, autoSize = _a.autoSize, onFocus = _a.onFocus, onBlur = _a.onBlur, onChange = _a.onChange;
    var _b = useState(false), isFocused = _b[0], setIsFocused = _b[1];
    var onKeyDown = function (e) {
        var el = e.target;
        el.style.height = 'inherit';
        var computed = window.getComputedStyle(el);
        var desiredHeight = el.scrollHeight;
        for (var _i = 0, _a = [
            'border-top-width',
            'padding-top',
            'padding-bottom',
            'border-bottom-width',
        ]; _i < _a.length; _i++) {
            var k = _a[_i];
            desiredHeight += parseInt(computed.getPropertyValue(k), 10);
        }
        el.style.height = desiredHeight + "px";
    };
    return (React.createElement(InputLayout, { id: id, label: label, errorMessage: errorMessage, isFilled: !!value, isFocused: isFocused, hasPlaceholder: !!placeholder, hasError: error || !!errorMessage, fullHeight: fullHeight, className: classnames(s['textarea-wrapper'], isFocused && s['focused'], wrapperClassName), skin: skin },
        React.createElement("textarea", { id: id, ref: ref, name: name, value: value || undefined, rows: rows, maxLength: maxLength, defaultValue: defaultValue || undefined, placeholder: placeholder, className: classnames(s['textarea'], fullHeight && s['full-height'], textareaClassName), onFocus: function (e) {
                setIsFocused(true);
                onFocus && onFocus(e);
            }, onBlur: function (e) {
                setIsFocused(false);
                onBlur && onBlur(e);
            }, onChange: function (e) {
                var v = e.target.value;
                onChange && onChange(v, e);
            }, onKeyDown: autoSize ? onKeyDown : undefined }),
        maxLength && typeof value !== 'undefined' && value !== null && (React.createElement("span", { className: classnames(s['symbols-left'], charactersRemainingClassName) }, maxLength - value.length))));
});
Textarea.displayName = 'Textarea';
export default Textarea;
//# sourceMappingURL=Textarea.js.map